import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import arr from './cert.js'

import './Certificates.css'
const Certificates = () => {
    return (
        <div id="certificates" className='mb-5'>
            <Container>
                <Row>
                    <Col lg='12' className='mb-5'>
                        <h2> Certificates </h2>
                    </Col>
                    <Col lg='12' md='12'>
                        <div className="pic-ctn">{arr.map((item, index) => <img key={index} src={item.value} alt={item.key} className="pic" />)}</div>
                    </Col>

                </Row>
            </Container>

        </div>
    )
}

export default Certificates